import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from "axios";
import useTableScroll from "../components/useTableScroll";
import { Mensaje} from '../components/mensajes2';
import { formatMoneda } from '../util/varios';
import { Dimmer } from '../components/spinner';

const CatalogoValorFisCon = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const efiscal = JSON.parse(localStorage.getItem('idvalorfiscconstruc'));

    const btnCancela = useRef();
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [select, setSelect] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'DESCRIPCIÓN', textAlign: 'center' },
        { label: 'PORCENTAJE', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idvalorfiscconstruc.includes(target.value)
                            || x.descriptor.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }



    const seleccionarEjercicioFiscal = () => {

        setActivate(true);

        let campos = '*';
        let nomtab = 'valorfiscconstruc';
        let orden = 'idvalorfiscconstruc';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
               
                setRecords(response.data)

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
            setActivate(false);

        })
    }

    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setActivo(true);
        setFilterFn({ fn: items => { return items; } });
    }

    const cancelar = () => {

        blanquear();
        props.onHideCancela();
    }

    const cerrarModal = () =>{
        blanquear();
        props.onHideCancela();

    }

    const seleccionarEfiscal = (index) => (event) => {
        props.onHideAcepta(values);
    };

    const seleccionarFila = (item,index) => (event) => {
        setItemSelect(index);
        setActivo(false);
        setSelect(parseInt(item.idvalorfiscconstruc));
        setValues(item);
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarEjercicioFiscal();
                setSelect(parseInt(efiscal));
            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className="fw-bold text-light"><h3>Seleccionar.</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => mensaje.titulo === 'Exito.' ? cerrarModal() :
                     setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idvalorfiscconstruc} style={{ padding: "0", cursor: 'pointer', backgroundColor: select === parseInt(item.idvalorfiscconstruc) ? "lightskyblue" : itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(item,index)}>
                                        <td className='py-2 text-center'>{item.idvalorfiscconstruc}</td>
                                        <td className='py-2 text-start'>{item.descripcion}</td>
                                        <td className='py-2 text-center'>{formatMoneda(item.porcentajeconstruc.toString().replace(".", ","),",",".",2)}</td>

                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} onClick={seleccionarEfiscal()}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoValorFisCon;